import { type HomeOneRegistrationRequest } from './api/homeOneRegistrationRequest'
import { type RegistrationType } from './consts'

export const resolveRegistrationType = (
  request: Pick<HomeOneRegistrationRequest, 'password'>,
): RegistrationType => {
  return request.password ? 'password' : 'passwordless'
}
